import { httpRequest } from "../../../utils/HttpRequest";
import { WorkHourStatisticsItem, WorkHourStatisticsQuery } from "./workHourType";

class WorkHourService {

    async workHourStatic(searchVo: any) {
        const apiUrl = "/zzw-vrm/statistics/workHourStatic";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    async workHourStaticExport(params: any) {
        const apiUrl = "/zzw-vrm/statistics/workHourStaticExport";
        return await httpRequest.postFile(apiUrl, params);
    }

    async workHourStaticDetail(searchVo: any) {
        const apiUrl = "/zzw-vrm/statistics/workHourDetail";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }
}
export const enquiryService = new WorkHourService();
